/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as TermsOfServiceImport } from './routes/terms-of-service'
import { Route as SignUpImport } from './routes/sign-up'
import { Route as SignInImport } from './routes/sign-in'
import { Route as ResetPasswordImport } from './routes/reset-password'
import { Route as PrivacyPolicyImport } from './routes/privacy-policy'
import { Route as PricingImport } from './routes/pricing'
import { Route as ForgotPasswordImport } from './routes/forgot-password'
import { Route as DeleteAccountImport } from './routes/delete-account'
import { Route as ChangePasswordImport } from './routes/change-password'
import { Route as DashboardImport } from './routes/_dashboard'
import { Route as DashboardIndexImport } from './routes/_dashboard.index'
import { Route as DashboardUpdatesImport } from './routes/_dashboard.updates'
import { Route as DashboardSettingsImport } from './routes/_dashboard.settings'
import { Route as DashboardImportImport } from './routes/_dashboard.import'
import { Route as DashboardCasesIndexImport } from './routes/_dashboard.cases.index'
import { Route as DashboardApplicantsIndexImport } from './routes/_dashboard.applicants.index'
import { Route as ClientPortalPublicCaseIdImport } from './routes/client-portal.public.$caseId'
import { Route as ClientPortalInternalSampleImport } from './routes/client-portal.internal.sample'
import { Route as DashboardCasesInactiveImport } from './routes/_dashboard.cases.inactive'
import { Route as DashboardCasesActiveImport } from './routes/_dashboard.cases.active'
import { Route as DashboardApplicantsApplicantIdImport } from './routes/_dashboard.applicants.$applicantId'
import { Route as ClientPortalInternalApplicantIdCaseIdImport } from './routes/client-portal.internal.$applicantId.$caseId'
import { Route as DashboardApplicantsApplicantIdCasesCaseNumberImport } from './routes/_dashboard.applicants.$applicantId.cases.$caseNumber'

// Create/Update Routes

const TermsOfServiceRoute = TermsOfServiceImport.update({
  path: '/terms-of-service',
  getParentRoute: () => rootRoute,
} as any)

const SignUpRoute = SignUpImport.update({
  path: '/sign-up',
  getParentRoute: () => rootRoute,
} as any)

const SignInRoute = SignInImport.update({
  path: '/sign-in',
  getParentRoute: () => rootRoute,
} as any)

const ResetPasswordRoute = ResetPasswordImport.update({
  path: '/reset-password',
  getParentRoute: () => rootRoute,
} as any)

const PrivacyPolicyRoute = PrivacyPolicyImport.update({
  path: '/privacy-policy',
  getParentRoute: () => rootRoute,
} as any)

const PricingRoute = PricingImport.update({
  path: '/pricing',
  getParentRoute: () => rootRoute,
} as any)

const ForgotPasswordRoute = ForgotPasswordImport.update({
  path: '/forgot-password',
  getParentRoute: () => rootRoute,
} as any)

const DeleteAccountRoute = DeleteAccountImport.update({
  path: '/delete-account',
  getParentRoute: () => rootRoute,
} as any)

const ChangePasswordRoute = ChangePasswordImport.update({
  path: '/change-password',
  getParentRoute: () => rootRoute,
} as any)

const DashboardRoute = DashboardImport.update({
  id: '/_dashboard',
  getParentRoute: () => rootRoute,
} as any)

const DashboardIndexRoute = DashboardIndexImport.update({
  path: '/',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardUpdatesRoute = DashboardUpdatesImport.update({
  path: '/updates',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardSettingsRoute = DashboardSettingsImport.update({
  path: '/settings',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardImportRoute = DashboardImportImport.update({
  path: '/import',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardCasesIndexRoute = DashboardCasesIndexImport.update({
  path: '/cases/',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardApplicantsIndexRoute = DashboardApplicantsIndexImport.update({
  path: '/applicants/',
  getParentRoute: () => DashboardRoute,
} as any)

const ClientPortalPublicCaseIdRoute = ClientPortalPublicCaseIdImport.update({
  path: '/client-portal/public/$caseId',
  getParentRoute: () => rootRoute,
} as any)

const ClientPortalInternalSampleRoute = ClientPortalInternalSampleImport.update(
  {
    path: '/client-portal/internal/sample',
    getParentRoute: () => rootRoute,
  } as any,
)

const DashboardCasesInactiveRoute = DashboardCasesInactiveImport.update({
  path: '/cases/inactive',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardCasesActiveRoute = DashboardCasesActiveImport.update({
  path: '/cases/active',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardApplicantsApplicantIdRoute =
  DashboardApplicantsApplicantIdImport.update({
    path: '/applicants/$applicantId',
    getParentRoute: () => DashboardRoute,
  } as any)

const ClientPortalInternalApplicantIdCaseIdRoute =
  ClientPortalInternalApplicantIdCaseIdImport.update({
    path: '/client-portal/internal/$applicantId/$caseId',
    getParentRoute: () => rootRoute,
  } as any)

const DashboardApplicantsApplicantIdCasesCaseNumberRoute =
  DashboardApplicantsApplicantIdCasesCaseNumberImport.update({
    path: '/cases/$caseNumber',
    getParentRoute: () => DashboardApplicantsApplicantIdRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_dashboard': {
      id: '/_dashboard'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof DashboardImport
      parentRoute: typeof rootRoute
    }
    '/change-password': {
      id: '/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof ChangePasswordImport
      parentRoute: typeof rootRoute
    }
    '/delete-account': {
      id: '/delete-account'
      path: '/delete-account'
      fullPath: '/delete-account'
      preLoaderRoute: typeof DeleteAccountImport
      parentRoute: typeof rootRoute
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordImport
      parentRoute: typeof rootRoute
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingImport
      parentRoute: typeof rootRoute
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyImport
      parentRoute: typeof rootRoute
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordImport
      parentRoute: typeof rootRoute
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInImport
      parentRoute: typeof rootRoute
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpImport
      parentRoute: typeof rootRoute
    }
    '/terms-of-service': {
      id: '/terms-of-service'
      path: '/terms-of-service'
      fullPath: '/terms-of-service'
      preLoaderRoute: typeof TermsOfServiceImport
      parentRoute: typeof rootRoute
    }
    '/_dashboard/import': {
      id: '/_dashboard/import'
      path: '/import'
      fullPath: '/import'
      preLoaderRoute: typeof DashboardImportImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/settings': {
      id: '/_dashboard/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof DashboardSettingsImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/updates': {
      id: '/_dashboard/updates'
      path: '/updates'
      fullPath: '/updates'
      preLoaderRoute: typeof DashboardUpdatesImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/': {
      id: '/_dashboard/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof DashboardIndexImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/applicants/$applicantId': {
      id: '/_dashboard/applicants/$applicantId'
      path: '/applicants/$applicantId'
      fullPath: '/applicants/$applicantId'
      preLoaderRoute: typeof DashboardApplicantsApplicantIdImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/cases/active': {
      id: '/_dashboard/cases/active'
      path: '/cases/active'
      fullPath: '/cases/active'
      preLoaderRoute: typeof DashboardCasesActiveImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/cases/inactive': {
      id: '/_dashboard/cases/inactive'
      path: '/cases/inactive'
      fullPath: '/cases/inactive'
      preLoaderRoute: typeof DashboardCasesInactiveImport
      parentRoute: typeof DashboardImport
    }
    '/client-portal/internal/sample': {
      id: '/client-portal/internal/sample'
      path: '/client-portal/internal/sample'
      fullPath: '/client-portal/internal/sample'
      preLoaderRoute: typeof ClientPortalInternalSampleImport
      parentRoute: typeof rootRoute
    }
    '/client-portal/public/$caseId': {
      id: '/client-portal/public/$caseId'
      path: '/client-portal/public/$caseId'
      fullPath: '/client-portal/public/$caseId'
      preLoaderRoute: typeof ClientPortalPublicCaseIdImport
      parentRoute: typeof rootRoute
    }
    '/_dashboard/applicants/': {
      id: '/_dashboard/applicants/'
      path: '/applicants'
      fullPath: '/applicants'
      preLoaderRoute: typeof DashboardApplicantsIndexImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/cases/': {
      id: '/_dashboard/cases/'
      path: '/cases'
      fullPath: '/cases'
      preLoaderRoute: typeof DashboardCasesIndexImport
      parentRoute: typeof DashboardImport
    }
    '/client-portal/internal/$applicantId/$caseId': {
      id: '/client-portal/internal/$applicantId/$caseId'
      path: '/client-portal/internal/$applicantId/$caseId'
      fullPath: '/client-portal/internal/$applicantId/$caseId'
      preLoaderRoute: typeof ClientPortalInternalApplicantIdCaseIdImport
      parentRoute: typeof rootRoute
    }
    '/_dashboard/applicants/$applicantId/cases/$caseNumber': {
      id: '/_dashboard/applicants/$applicantId/cases/$caseNumber'
      path: '/cases/$caseNumber'
      fullPath: '/applicants/$applicantId/cases/$caseNumber'
      preLoaderRoute: typeof DashboardApplicantsApplicantIdCasesCaseNumberImport
      parentRoute: typeof DashboardApplicantsApplicantIdImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  DashboardRoute: DashboardRoute.addChildren({
    DashboardImportRoute,
    DashboardSettingsRoute,
    DashboardUpdatesRoute,
    DashboardIndexRoute,
    DashboardApplicantsApplicantIdRoute:
      DashboardApplicantsApplicantIdRoute.addChildren({
        DashboardApplicantsApplicantIdCasesCaseNumberRoute,
      }),
    DashboardCasesActiveRoute,
    DashboardCasesInactiveRoute,
    DashboardApplicantsIndexRoute,
    DashboardCasesIndexRoute,
  }),
  ChangePasswordRoute,
  DeleteAccountRoute,
  ForgotPasswordRoute,
  PricingRoute,
  PrivacyPolicyRoute,
  ResetPasswordRoute,
  SignInRoute,
  SignUpRoute,
  TermsOfServiceRoute,
  ClientPortalInternalSampleRoute,
  ClientPortalPublicCaseIdRoute,
  ClientPortalInternalApplicantIdCaseIdRoute,
})

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_dashboard",
        "/change-password",
        "/delete-account",
        "/forgot-password",
        "/pricing",
        "/privacy-policy",
        "/reset-password",
        "/sign-in",
        "/sign-up",
        "/terms-of-service",
        "/client-portal/internal/sample",
        "/client-portal/public/$caseId",
        "/client-portal/internal/$applicantId/$caseId"
      ]
    },
    "/_dashboard": {
      "filePath": "_dashboard.tsx",
      "children": [
        "/_dashboard/import",
        "/_dashboard/settings",
        "/_dashboard/updates",
        "/_dashboard/",
        "/_dashboard/applicants/$applicantId",
        "/_dashboard/cases/active",
        "/_dashboard/cases/inactive",
        "/_dashboard/applicants/",
        "/_dashboard/cases/"
      ]
    },
    "/change-password": {
      "filePath": "change-password.tsx"
    },
    "/delete-account": {
      "filePath": "delete-account.tsx"
    },
    "/forgot-password": {
      "filePath": "forgot-password.tsx"
    },
    "/pricing": {
      "filePath": "pricing.tsx"
    },
    "/privacy-policy": {
      "filePath": "privacy-policy.tsx"
    },
    "/reset-password": {
      "filePath": "reset-password.tsx"
    },
    "/sign-in": {
      "filePath": "sign-in.tsx"
    },
    "/sign-up": {
      "filePath": "sign-up.tsx"
    },
    "/terms-of-service": {
      "filePath": "terms-of-service.tsx"
    },
    "/_dashboard/import": {
      "filePath": "_dashboard.import.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/settings": {
      "filePath": "_dashboard.settings.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/updates": {
      "filePath": "_dashboard.updates.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/": {
      "filePath": "_dashboard.index.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/applicants/$applicantId": {
      "filePath": "_dashboard.applicants.$applicantId.tsx",
      "parent": "/_dashboard",
      "children": [
        "/_dashboard/applicants/$applicantId/cases/$caseNumber"
      ]
    },
    "/_dashboard/cases/active": {
      "filePath": "_dashboard.cases.active.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/cases/inactive": {
      "filePath": "_dashboard.cases.inactive.tsx",
      "parent": "/_dashboard"
    },
    "/client-portal/internal/sample": {
      "filePath": "client-portal.internal.sample.tsx"
    },
    "/client-portal/public/$caseId": {
      "filePath": "client-portal.public.$caseId.tsx"
    },
    "/_dashboard/applicants/": {
      "filePath": "_dashboard.applicants.index.tsx",
      "parent": "/_dashboard"
    },
    "/_dashboard/cases/": {
      "filePath": "_dashboard.cases.index.tsx",
      "parent": "/_dashboard"
    },
    "/client-portal/internal/$applicantId/$caseId": {
      "filePath": "client-portal.internal.$applicantId.$caseId.tsx"
    },
    "/_dashboard/applicants/$applicantId/cases/$caseNumber": {
      "filePath": "_dashboard.applicants.$applicantId.cases.$caseNumber.tsx",
      "parent": "/_dashboard/applicants/$applicantId"
    }
  }
}
ROUTE_MANIFEST_END */
